import { render, staticRenderFns } from "./tarsOrderModal.vue?vue&type=template&id=ba5af748&scoped=true&"
import script from "./tarsOrderModal.vue?vue&type=script&lang=js&"
export * from "./tarsOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./tarsOrderModal.vue?vue&type=style&index=0&id=ba5af748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5af748",
  null
  
)

export default component.exports